import styledNormalize from 'styled-normalize'
import { createGlobalStyle } from 'styled-components'

export const theme = {
  // bg: '#9dbedc',
  bg: '#AFAFAF',
  ['tag-red']: '#ff554f',
  ['tag-orange']: '#ffb428',
  ['tag-green']: '#25c438',
}

export const GlobalStyle = createGlobalStyle`
  ${styledNormalize}
  
  html {
    box-sizing: border-box;
  }
  
  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  .ps {
    overflow: hidden;
  }
  
  :focus {
    outline: 0;
  }
  
  body {
    font-family: sans-serif;
    -webkit-font-smoothing: antialiased;
  	-moz-osx-font-smoothing: grayscale;
  }
`